export default "__VITE_ASSET__758096d7__"